import { hasStrokeStyle } from './comparisons';
import type { ExcalidrawElement } from './types';

export const supportsFixedCornerRadius = (
  element: Pick<ExcalidrawElement, 'type'>
) => element.type === 'rectangle' || element.type === 'diamond';

export const supportsCustomStrokeDash = (
  element: Pick<ExcalidrawElement, 'type'>
) => hasStrokeStyle(element.type);

export const normalizeStrokeDash = (
  value: ExcalidrawElement['strokeDash']
): readonly [number, number] | null =>
  Array.isArray(value) &&
  value.length === 2 &&
  value.every(
    length =>
      typeof length === 'number' &&
      Number.isFinite(length) &&
      length > 0 &&
      length <= 1000
  )
    ? [value[0], value[1]]
    : null;

export const isValidStrokeDashOffset = (value: unknown): value is number =>
  typeof value === 'number' &&
  Number.isFinite(value) &&
  value >= -1000 &&
  value <= 1000;
